module.exports = new __parcel__URL__("29088_sq.db31f515.jpg").toString();